import React, { useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@mui/material'
import { contagem } from '../../utils/localReset/messages'

// O reset.scss zera marcador, margem e entrelinha das listas (QA HML U6/U7).
const listSx = (listStyle) => ({
  listStyle,
  pl: 3,
  my: 1.5,
  '& li': { lineHeight: 1.5, mb: 0.5 },
})

export function CleanupIntroDialog({ open, onCancel, onContinue }) {
  return (
    <Dialog
      open={open}
      maxWidth='sm'
      fullWidth
      aria-labelledby='cleanup-intro-title'
    >
      <DialogTitle id='cleanup-intro-title'>
        Limpar e recarregar os dados
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 1 }}>
          Isto apaga os dados guardados neste aparelho e baixa tudo de novo do
          servidor. Você continua logado. O processo tem 4 passos e leva alguns
          minutos:
        </Typography>
        <Box component='ol' sx={listSx('decimal')}>
          <li>Enviar ao servidor o que ainda não foi enviado.</li>
          <li>Salvar um arquivo de backup neste aparelho.</li>
          <li>Limpar os dados do aparelho.</li>
          <li>Baixar os dados de novo (você escolhe as fazendas).</li>
        </Box>
        <Typography sx={{ mt: 1.5 }}>
          Mantenha esta aba aberta e com internet até o fim.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancelar</Button>
        <Button variant='contained' onClick={onContinue}>
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

function pendingLine(p) {
  if (!p || p.loading) return 'Conferindo o que está pendente de envio...'
  if (p.unreadable)
    return 'Não foi possível conferir o que está pendente agora (a limpeza só segue depois de conferir).'
  const n = p.dirtyRecords ?? 0
  if (n === 0) return 'Nenhum registro pendente de envio.'
  if (n === 1)
    return '1 registro pendente de envio (será enviado antes de limpar).'
  return `${n} registros pendentes de envio (serão enviados antes de limpar).`
}

function farmsLine(n) {
  if (!n) return 'Nenhuma fazenda baixada neste aparelho.'
  return `${contagem(n, 'fazenda baixada', 'fazendas baixadas')} neste aparelho.`
}

export function CleanupConfirmDialog({
  open,
  farmsCount,
  pending,
  onCancel,
  onConfirm,
}) {
  const [entendi, setEntendi] = useState(false)
  return (
    <Dialog
      open={open}
      maxWidth='sm'
      fullWidth
      aria-labelledby='cleanup-confirm-title'
    >
      <DialogTitle id='cleanup-confirm-title'>Confirmar limpeza</DialogTitle>
      <DialogContent>
        <Box component='ul' sx={listSx('disc')}>
          <li>{farmsLine(farmsCount)}</li>
          <li>{pendingLine(pending)}</li>
          <li>
            Um arquivo de backup será salvo neste aparelho antes de apagar.
          </li>
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={entendi}
              onChange={(e) => setEntendi(e.target.checked)}
            />
          }
          label='Entendi que os dados deste aparelho serão apagados e baixados de novo, e que devo guardar o arquivo de backup.'
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancelar</Button>
        <Button
          variant='contained'
          color='error'
          disabled={!entendi}
          onClick={onConfirm}
        >
          Limpar agora
        </Button>
      </DialogActions>
    </Dialog>
  )
}
